import React, {useCallback, useContext} from "react";
import 'react-perfect-scrollbar/dist/css/styles.css'
import './ScroolBar.scss'
import PerfectScrollbar from "react-perfect-scrollbar";
import {GlobalContext} from "@tools/globalContext";

interface Props {
    options?: any
    style?: any
    containerRef?: any
    onYReachStart?: () => void
    onYReachEnd?: () => void
    children: any
}

const ScrollBar: React.FC<Props> = props => {
    const {userAgent} = useContext(GlobalContext);
    const mobile = userAgent.isMobile;

    return <>
        {!mobile && <PerfectScrollbar
            {...props.options && {options: props.options}}
            {...props.containerRef && {containerRef : props.containerRef}}
            {...props.style && {style: props.style}}
            {...props.onYReachStart && {onYReachStart: props.onYReachStart}}
            {...props.onYReachEnd && {onYReachEnd: props.onYReachEnd}}
        >
            {props.children}
        </PerfectScrollbar>}
        {mobile && <div style={{overflowY: "auto", flex: "1 1 auto"}}>{props.children}</div>}
    </>
};

export default ScrollBar;
